<template>

    <div class="madagascar" id="mada-dates">
        <div class="page-container">

                <transition
                        v-on:before-enter="beforeEnter"
                        v-on:enter="enter"
                        v-on:leave="leave"
                        v-bind:css="false"
                >
                    <router-view :key="$route.fullPath"></router-view>
                </transition>

        </div>

        <NavDates
                v-if="$store.state.language"
                v-bind:pages="$store.state.pages"
                  class="nav-dates"
        />

        <div class="test">
            <screen-sizes/> | lang {{$store.state.language}} |
            <router-link to="/">Home</router-link> <br>
        </div>

    </div>
</template>

<script>
    import { gsap, Power3 } from "gsap";
    import NavDates from "@/components/nav/NavDates";
    import ScreenSizes from "shared-src/debug/ScreenSizes";
    import PageDateModel from "../PageDateModel";
    import TranslatedObject from "../../../shared-src/data/TranslatedObject";

    export default {
        name: "MadaDates",
        components: {NavDates,ScreenSizes},
        data(){
            return{
                "transitionIn":"fadeIn",
                "transitionOut":"fadeOut",
                transiParams:{
                    duration:1
                }

            }
        },
        created() {
            PageDateModel.boot();
            this.$root.$on("changeLanguage",function(langCode){
                this.$store.state.language=langCode;
              TranslatedObject.currentLanguage=langCode;
                this.$router.push(PageDateModel.first().url());
            });
        },
        methods: {
            beforeEnter: function (el) {
                console.log("beforeEnter",this.$router.currentRoute,el);

                //el.style.opacity = 0
                //el.style.transformOrigin = 'left'
            },
            enter: function (el, done) {
                console.log("enter",el,done);
                let tl=gsap.timeline({onComplete:done});
                let moveBy=screen.width*0.9;

                switch (this.transitionIn) {
                    case "fadeIn":
                        tl.to(el,{
                            opacity:0,
                            duration:0
                            }
                        );
                        tl.to(el,{
                            opacity:1,
                            duration:1,
                            delay:0.5
                        }
                        );
                        break;
                    case "slideInLeft":
                        tl.to(el,{x:-moveBy,duration:0});
                        tl.to(el,{
                            x:0,
                            duration:this.transiParams.duration,
                            delay:0.0,
                            ease:Power3.easeInOut
                        });
                        break;
                    case "slideInRight":
                        tl.to(el,{x:moveBy,duration:0});
                        tl.to(el,{
                            x:0,
                            duration:this.transiParams.duration,
                            delay:0.0,
                            ease:Power3.easeInOut
                        });
                        break;
                }

                //Velocity(el, { opacity: 1, fontSize: '1.4em' }, { duration: 300 })
                //Velocity(el, { fontSize: '1em' }, { complete: done })
            },
            leave: function (el, done) {
                let moveBy=screen.width*1.2;
                console.log("leave",el,done);
                let tl=gsap.timeline({onComplete:done});
                switch (this.transitionOut) {
                    case "fadeOut":
                        tl.to(el, {
                            opacity: 0,
                            duration: this.transiParams.duration / 2
                        });
                        break;
                    case "slideOutLeft":
                        tl.to(el, {
                            x:-moveBy,
                            duration:this.transiParams.duration,
                            ease:Power3.easeInOut
                        });
                        break;
                    case "slideOutRight":
                        tl.to(el, {
                            x:moveBy,
                            duration:this.transiParams.duration,
                            ease:Power3.easeInOut
                        });
                        break;
                }
            }
        },
        watch: {
            '$route' (to, from) {
                console.log("transi watch",from.fullPath,to.fullPath)
                if(to.name==="home"){
                    this.$store.state.language=null;
                }
                if(to.name==="home" || from.name==="home"){
                    this.transitionIn="fadeIn";
                    this.transitionOut="fadeOut";
                }else{
                    for(let page of this.$store.state.pages){
                        console.log("test",page.id,from.params.id,to.params.id);
                        if(String(page.id)===String(to.params.id)){
                            this.transitionOut="slideOutRight";
                            this.transitionIn="slideInLeft";
                            return;
                        }
                        if(String(page.id)===String(from.params.id)){
                            this.transitionOut="slideOutLeft";
                            this.transitionIn="slideInRight";
                            return;
                        }
                    }
                }
                //this.transitionName = toDepth < fromDepth ? 'slide-right' : 'slide-left'
            }
        }
    }
</script>

<style lang="less">

    //reset----------------------
    html,body,*{
        box-sizing: border-box;
    }
    body{

    }
    @import "../../../shared-src/scroll-skin.less";
    @import "../typographie.less";
    @import "~@material/elevation/dist/mdc.elevation.min.css";
    @import "~animate.css";

    .test{
        position: absolute;
        z-index: 1;
        color: white;
        font-size: 10px;
        font-family: monospace;
        padding: 8px;
        a{
            color: white;
        }
    }
    //global styles---------------
    .madagascar{
        background-color: #491114;
        background-size: cover;
        background-repeat: no-repeat;
        background-image: url("../layout/bg-dates.jpg");
        color: #fff;
        overflow: hidden;

    }

    #mada-dates{
        //layout variables-------------
        --nav-height:7vw;

        --page-width:70vw;
        --page-height:35vw;

        width: 100%;
        height: 100%;
        position: absolute;
        .nav-dates{
            position: absolute;
            bottom: 2px;
            left: 0;
            width: 100%;
        }
    }

    .page-container{
        position: absolute;
        width: calc( 100vw);
        height: calc( 100vh - var(--nav-height) );
        //outline: 1px solid green;
        //outline-offset: -10px;
        >*{
            position: absolute;
            left: calc( 100vw / 2 - var(--page-width) / 2);
            top: calc( 50%  - var(--page-height) / 2);
            //outline: 1px solid pink;
            width: var(--page-width);
            height: var(--page-height);
        }
    }
    .nav-dates{
        //outline: 1px solid red;
        height: var(--nav-height);
    }





</style>